import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'md'
  },
  theme: {
    dark: false,
    light: {
      primary: '#3f51b5',
      secondary: '#00bcd4',
      accent: '#cddc39',
      error: '#f44336',
      warning: '#ff5722',
      info: '#ff9800',
      success: '#8bc34a'
    }
  },
  customProperties: true
})

// light: {
//   primary: '#13232B',
//   secondary: '#2B4851',
//   accent: '#B0BEC5',
//   error: '#D6473A',
//   info: '#7799B8',
//   success: '#4CAF50',
//   warning: '#E57436'
// }
